import apiSlice from "../api/apiSlice";

export const bilateralEnergyAllocationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getBilateralEnergyAllocationsByCommunityIdPagination: builder.query({
      query: ({
        limit,
        page,
        date,
        time,
        providerMeterId,
        receiverMeterId,
        communityId,
        sortColumn,
        sortDirection,
      }) => ({
        url:
          `/communities/${communityId}/bilateral_energy_allocations/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${providerMeterId ? `&provider_meter_id=${providerMeterId}` : ""}` +
          `${receiverMeterId ? `&receiver_meter_id=${receiverMeterId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "BilateralEnergyAllocation", id: "LIST" }],
    }),
    /* EXPORT ZIP */
    exportBilateralEnergyAllocations: builder.mutation({
      query: ({ communityId, startDate, endDate }) => ({
        url:
          `/communities/${communityId}/bilateral_energy_allocations/export?` +
          `start_date=${startDate}&end_date=${endDate}`,
        method: "GET",
        responseHandler: async (response) => response.blob(),
        cache: "no-cache",
      }),
    }),
  }),
});

export const {
  useGetBilateralEnergyAllocationsByCommunityIdPaginationQuery,
  useExportBilateralEnergyAllocationsMutation,
} = bilateralEnergyAllocationsApiSlice;
